import React from 'react';
import { Block } from '../../other/block';

interface FormProps {
  formHtml: string;
  noSpacing?: boolean;
}

export const Form = ({ formHtml, noSpacing }: FormProps) => {

  return (
    <Block className="text-center" noSpacing={noSpacing}>
      <div dangerouslySetInnerHTML={{__html: formHtml}} />
    </Block>
  );
};
